module.exports = "https://portperrypedals.ca/_res/img/pphf-goal-reached.1d6a9fc.jpeg";